import { render, staticRenderFns } from "./NewMachine.vue?vue&type=template&id=ec64dc60&"
import script from "./NewMachine.vue?vue&type=script&lang=js&"
export * from "./NewMachine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports